import { Values } from '../values.class'

/**
 * @file Defines the {@link BetValues} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Class for handling bet values
  * @extends BetValues
  */
  export class BetValues extends Values {

    /** Initialize bet values */
    constructor() {
        super() //Call parent constructor
    }

    /**
     * Initialise bet values
     * @param {string[]} v_ - Array of possible bet values
     * @param {number|string} d_ - Default stake value
     */
    init(v_, d_) {
        
        this._values = v_                                       //Store values
        let d        = typeof d_ === 'string' ? Number(d_) : d_ //Store default value

        //Loop through bet values
        for (let i = 0; i < v_.length; i++) {

            let v = Number(v_[i].replace(/[^0-9.-]+/g,"")) //Store bet value converted into a number

            //If bet value is the default value
            if (v === d) {
                this._index = i //Set index
            }

        }
        
        this.changed.dispatch(this.value())

    }

  }

